import permission from '@/plugins/auth'
import i18n from '@/Language';
export const renderHeader = (h, { column }) => {
    return h('div', {
    style: {
        'white-space': 'nowrap',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis'
    }
    }, column.label)
}

/**
 * 计算table列宽度
 * @param {*} label
 * @param {*} minWidth
 * @returns
 */
export const calcMinWidth = (label, minWidth = 150) => {
    // 根据文字长度计算最小宽度（中文按2个字符计算）
    const chineseChars = label.match(/[\u4e00-\u9fa5]/g)?.length || 0;
    const otherChars = label.length - chineseChars;
    return Math.max(minWidth, (chineseChars * 16 + otherChars * 8) + 40); // 基础宽度+padding
}

// table统一header样式
export const headerCellStyle = {
    background: '#f8f8f8',
    color: '#afafaf',
    fontSize: '13px',
    borderColor: '#f0f0f0'
}

export const cellStyle = {
    borderColor: '#f0f0f0'
}

/**
 * 计算table列宽度（支持多语言）
 * @param {string} label - 标签文本
 * @param {number} minWidth - 最小宽度，默认150
 * @param {string} language - 可选，指定语言类型
 * @returns {number}
 */
export const calcMinWidthMinority = (label, minWidth = 150, language) => {
    if (!label || label.length === 0) return minWidth;

    // 获取字符宽度系数
    const getCharWidthFactor = (char) => {
        const charCode = char.charCodeAt(0);

        // 1. 中文字符（包含CJK统一表意文字）
        if (charCode >= 0x4E00 && charCode <= 0x9FFF) {
            return 2; // 中文字符通常较宽
        }

        // 2. 韩文
        if (charCode >= 0xAC00 && charCode <= 0xD7AF) {
            return 1.4;
        }

        // 3. 日文假名
        if ((charCode >= 0x3040 && charCode <= 0x309F) || // 平假名
            (charCode >= 0x30A0 && charCode <= 0x30FF)) { // 片假名
            return 1.3;
        }

        // 4. 阿拉伯语、希伯来语等从右向左书写的字符
        if ((charCode >= 0x0600 && charCode <= 0x06FF) || // 阿拉伯语
            (charCode >= 0x0750 && charCode <= 0x077F) || // 阿拉伯语补充
            (charCode >= 0xFB50 && charCode <= 0xFDFF) || // 阿拉伯表现形式-A
            (charCode >= 0xFE70 && charCode <= 0xFEFF) || // 阿拉伯表现形式-B
            (charCode >= 0x0590 && charCode <= 0x05FF)) { // 希伯来语
            return 1.2;
        }

        // 5. 泰语
        if (charCode >= 0x0E00 && charCode <= 0x0E7F) {
            return 0.8;
        }

        // 6. 西里尔字母（俄语等）
        if (charCode >= 0x0400 && charCode <= 0x04FF) {
            return 1.1;
        }

        // 7. 特殊字符和符号
        if (charCode >= 0x2000 && charCode <= 0x206F) { // 常用标点符号
            return 0.5;
        }

        // 8. 数字和英文字符（默认）
        return 1.0;
    };

    // 计算总宽度
    let totalWidth = 0;
    for (let i = 0; i < label.length; i++) {
        totalWidth += getCharWidthFactor(label[i]);
    }

    // 基础宽度 + padding + 一定的安全边距
    const calculatedWidth = Math.ceil(totalWidth * 8 + 40);

    return Math.max(minWidth, calculatedWidth);
};

// 新增：计算操作列最小宽度的方法
// 标准模式(standard)：根据当前显示的按钮数量动态计算宽度，如果超过4个按钮且可能存在条件显隐，则按最长按钮宽度计算
// 普通模式(normal)：只按权限计算当前按钮操作栏宽度
export const calcActionColumnWidth = (buttonConfigs, type = 'standard') => {
    const visibleButtons = buttonConfigs.filter(btn =>
        permission.hasPermiOr(btn.permission) !== false
    );

    // 计算当前显示模式（前2个+更多）的宽度
    let currentWidth = 0;
    let labels = [];
    if (visibleButtons.length > 3) {
        labels = visibleButtons.slice(0, 2).map(btn =>
            typeof btn.label === 'function' ? btn.label() : btn.label
        );
        labels.push(i18n.t('device.more'));
        currentWidth = calcMinWidthMinority(labels.join(''), 80) + 12; // 加上图标宽度
    } else {
        labels = visibleButtons.map(btn =>
            typeof btn.label === 'function' ? btn.label() : btn.label
        );
        currentWidth = calcMinWidthMinority(labels.join(''), 80);
    }

    // 计算可能的最大宽度：前3个按钮的宽度
    const maxButtons = visibleButtons.slice(0, 3);
    if (maxButtons.length > 0 && type === 'standard') {
        const maxLabels = maxButtons.map(btn =>
            typeof btn.label === 'function' ? btn.label() : btn.label
        );
        const maxWidth = calcMinWidthMinority(maxLabels.join(''), 80);

        // 取较大值，确保足够宽
        return Math.max(currentWidth, maxWidth);
    }

    return currentWidth;
};

export const getInfoConfigComp = ({list, moduleName, type = 'checked'}) => {
    // 从本地存储读取列配置
    const savedSettingsStr = localStorage.getItem('columnSettings')
    const savedSettings = savedSettingsStr ? JSON.parse(savedSettingsStr) : {}
    const moduleSettings = savedSettings[moduleName] || []
    const defaultConfig = list
    
    if (moduleSettings.length > 0) {
        try {
            // 将默认配置转换为Map，方便查找
            const defaultMap = defaultConfig.reduce((acc, item) => {
                acc[item.prop] = item;
                return acc;
            }, {});
            
            // 先处理保存的配置，保留其顺序和固定设置
            const savedMerged = moduleSettings.map(item => {
                const defaultItem = defaultMap[item.prop];
                if (defaultItem) {
                    // 如果默认配置中存在，则合并
                    if (type === 'checked') {
                        // 当type为checked时，过滤掉visible为false的列
                        if (item.visible !== false) {
                            const mergedItem = { ...defaultItem, ...item };
                            if (!item.fixed) {
                                delete mergedItem.fixed;
                            }
                            return mergedItem;
                        }
                    } else {
                        // 当type不是checked时，不过滤，保留所有列
                        return { ...defaultItem, ...item };
                    }
                }
                return null;
            }).filter(Boolean);
            
            // 找出没有在保存配置中出现的默认列
            const savedProps = new Set(moduleSettings.map(item => item.prop).filter(Boolean));
            const missingDefaultItems = defaultConfig.filter(item => !savedProps.has(item.prop));
            
            // 根据type过滤缺失的默认列
            let filteredMissingItems = missingDefaultItems;
            if (type === 'checked') {
                // 对于checked模式，只添加visible不为false的列（默认都是可见的）
                filteredMissingItems = missingDefaultItems;
            }
            
            // 合并保存的列和缺失的默认列（缺失的列放在最后）
            const mergedConfig = [...savedMerged, ...filteredMissingItems];
            
            return mergedConfig;
        } catch (e) {
            console.error('Failed to parse saved column settings:', e)
            return defaultConfig
        }
    }
    return defaultConfig
}
